// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"617":"95d12b35","663":"57749025"}[chunkId] + ".chunk.css";
};